/**
 * "Wo Ist?" logo — a FindMy-style drop pin: green outer with a white
 * inner ring and a small dark center dot, the visual signature of the
 * Apple FindMy / "Wo Ist?" app on iOS.
 */
export function Logo({
  size = 32,
  className = '',
  withGlow = false,
}: {
  size?: number;
  className?: string;
  withGlow?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 48 56"
      width={size}
      height={(size * 56) / 48}
      className={className}
      aria-label="Wo Ist?"
      style={
        withGlow
          ? { filter: 'drop-shadow(0 6px 18px rgba(48,209,88,0.45))' }
          : undefined
      }
    >
      <defs>
        <linearGradient id="wi-pin-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5be481" />
          <stop offset="55%" stopColor="#30d158" />
          <stop offset="100%" stopColor="#1ea846" />
        </linearGradient>
        <radialGradient id="wi-pin-shine" cx="0.35" cy="0.25" r="0.55">
          <stop offset="0%" stopColor="rgba(255,255,255,0.55)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </radialGradient>
      </defs>
      {/* drop shape — circle with bottom point */}
      <path
        d="M24 2C12.954 2 4 10.954 4 22c0 13.5 16.5 28.5 19.18 30.86a1.25 1.25 0 0 0 1.64 0C27.5 50.5 44 35.5 44 22 44 10.954 35.046 2 24 2z"
        fill="url(#wi-pin-grad)"
      />
      <path
        d="M24 2C12.954 2 4 10.954 4 22c0 13.5 16.5 28.5 19.18 30.86a1.25 1.25 0 0 0 1.64 0C27.5 50.5 44 35.5 44 22 44 10.954 35.046 2 24 2z"
        fill="url(#wi-pin-shine)"
      />
      {/* white inner halo */}
      <circle cx="24" cy="22" r="10" fill="#ffffff" />
      {/* dark center dot */}
      <circle cx="24" cy="22" r="3.6" fill="#1c1c1e" />
    </svg>
  );
}
